import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  header: {
    flexWrap: 'nowrap',
    alignItems: 'center'
  },
  container: {
    position: 'relative',
    padding: 0
  },
  fixedButtonContainer: {
    position: 'fixed',
    top: theme.sizes.headerHeight + 40,
    left: 0,
    display: 'flex',
    flexDirection: 'column'
  },
  icon: {
    height: 48,
    width: 48
  },
  iconImg: {
    transform: 'rotate(180deg)'
  },
  navigatorIconImg: {
    height: 40,
    width: 40,
    transform: 'rotate(180deg)'
  },
  copyButton: {
    padding: theme.spacing(3),
    borderRadius: '50%',
    // Reskin: icon-only copy buttons hover like the other icon buttons (bark50), visible on beige rows and panels.
    ...reskinStyles(theme, { '&&:hover': { backgroundColor: theme.colorPalette.beige_50 } })
  },
  rightLabel: {
    fontSize: 14,
    display: 'inline',
    marginRight: theme.spacing(2)
  },
  rightValue: {
    fontSize: 14,
    display: 'inline'
  },
  rightContainer: {
    padding: 0
  },
  link: {
    color: theme.colors.action_text,
    fontWeight: 500,
    '&:hover': {
      textDecoration: 'underline'
    },
    ...reskinStyles(theme, theme.actionStyles.link)
  }
});

export default makeStyles(styles);
